import { Server } from './../interfaces/server.model';
import { NotificationsService } from 'angular2-notifications';
import { ServersService } from './../services/servers.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-server-list',
  templateUrl: './server-list.component.html'
})
export class ServerListComponent implements OnInit {

  public serverNameValue: String = '';
  private serversLoading: Boolean = true;
  public servers: Array<Server> = [];

  constructor(
    private serversService: ServersService,
    private notificationsService: NotificationsService,
    private router: Router
  ) { }

  ngOnInit() {
    this.serversService.getAllCompanyServersDashboard().subscribe(
      (servers) => {
        this.servers = servers;
        this.serversLoading = false;
      },
      (error) => {
        this.notificationsService.success('Ups!', 'Błąd przy pobieraniu listy serwerów');
      }
    )
  }

  buyServices(server) {
    this.router.navigateByUrl('/service/offer?for_service=' + server.service);
  }
}



// WEBPACK FOOTER //
// ./src/app/server/server-list.component.ts